import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  VolumeOff as VolumeOffIcon,
  VolumeUp as VolumeUpIcon,
} from "@mui/icons-material";
import useGameSoundMute from "../../hooks/useGameSoundMute";

const SoundMuteButton = ({ floating = false, sx = {} }) => {
  const { muted, toggleMute } = useGameSoundMute();

  const button = (
    <Tooltip title={muted ? "Unmute sounds" : "Mute sounds"}>
      <IconButton
        onClick={toggleMute}
        color="inherit"
        aria-label={muted ? "Unmute game sounds" : "Mute game sounds"}
        sx={{
          bgcolor: floating ? "rgba(0,0,0,0.45)" : "transparent",
          border: floating ? "1px solid rgba(255,255,255,0.2)" : "none",
          "&:hover": {
            bgcolor: floating ? "rgba(0,0,0,0.65)" : "rgba(255,255,255,0.08)",
          },
        }}
      >
        {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
      </IconButton>
    </Tooltip>
  );

  if (floating) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 12,
          right: 12,
          zIndex: 1300,
          ...sx,
        }}
      >
        {button}
      </Box>
    );
  }

  return button;
};

export default SoundMuteButton;
